module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.20.0@babel-runtime/core-js/promise.js
// module id = 44
// module chunks = 1